// Split out of prefill-layers.js (2026-08-06 barrel-omission fix). The
// property-autocomplete dropdown functions that stayed in prefill-layers.js
// (openAutocompleteDropdown, closeAutocompleteDropdown, autocompletePropKey,
// prefillValue, moveThroughList) statically import `props`/`propsKeys`/
// `getPropertyValues` from '@symbo.ls/ui/Autocomplete/props' — a package
// that does not exist on disk in this checkout (its node_modules symlink
// points at a `platform/uikit/ui` directory that was never checked out
// here), so that whole module can't load. These six functions never
// touched that import — they only reach each other through `this.call`
// — so they're extracted here to unblock `el.call('prefillColorValue' |
// 'prefillComponentValue' | 'prefillFunctionValue' | 'prefillSequenceValue'
// | 'setPrefillValues' | 'sequenceNameToDSItem' | 'prefillThemeValue', …)`
// without needing the missing package. See prefill-layers.js for the
// still-blocked half.

export function sequenceNameToDSItem(name) {
  if (name === 'fontSize') {
    return this.getDesignSystem('typography')
  }
  if (name === 'animationDuration') {
    return this.getDesignSystem('timing')
  }
  return this.getDesignSystem('spacing')
}

export function prefillSequenceValue(sequenceName) {
  const dsItem = this.call('sequenceNameToDSItem', sequenceName)

  const { sequence } = this.call('generateSequence', {
    base: dsItem.base,
    ratio: dsItem.ratio,
    range: dsItem.range || [-5, 12],
    subSequence: true,
    scales: {},
    sequence: {},
    vars: {}
  })

  if (!sequence) {
    return
  }

  this.call('setPrefillValues', Object.keys(sequence))
}

export function prefillColorValue() {
  const colors = Object.keys(this.getDesignSystem('color'))
  const gradients = Object.keys(this.getDesignSystem('gradient'))

  const colorList = [...colors, ...gradients].sort()

  this.call('setPrefillValues', colorList)
}

// The one prefill sibling that was never written (audit finding). By
// analogy with prefillColorValue: `theme` design-system keys (card,
// dialog, document, …) are flat, same shape as `color` — see
// shared/designSystem/theme.js.
export function prefillThemeValue() {
  const themes = Object.keys(this.getDesignSystem('theme'))

  this.call('setPrefillValues', themes)
}

export function prefillFunctionValue() {
  const functions = Object.keys(this.getRootState('functions'))
  const methods = Object.keys(this.getRootState('methods'))

  const functionList = [...functions, ...methods].sort()

  this.call('setPrefillValues', functionList)
}

export function prefillComponentValue() {
  const components = Object.keys(this.getRootState('components'))
  const smblsComponents = Object.keys(this.getRootContext('components'))
    .filter((key) => key.startsWith('smbls.'))
    .map((key) => key.replace('smbls.', ''))

  const componentList = [...components, ...smblsComponents].sort()

  this.call('setPrefillValues', componentList)
}

export function setPrefillValues(values, withFunctionFallback) {
  const value = this.node.textContent
  const regex = new RegExp(`^${value}`, 'iug')
  const matchedValues = value ? values?.filter((key) => regex.test(key)) : []

  if (!matchedValues.length && withFunctionFallback) {
    // Was a bare `prefillFunctionValue()` call — invoked without `this`,
    // which breaks prefillFunctionValue's own `this.getRootState(…)` reads.
    // Sibling functions reach each other via `this.call`, never a raw
    // reference (same rule as project-file imports).
    this.call('prefillFunctionValue')
    return
  }

  this.state.replace({
    list: matchedValues,
    prefill: matchedValues[0] ?? ''
  })
}
